export default {
  subtitle: {
    en: 'black friday special',
  },
}
